<template>
  <div class="editPage" v-loading="subLoading">
    <qx-card :title="'新增保养记录'">
      <BaseForm ref="baseForm" @plateNumberChange="plateNumberChange"/>
      <MaintenanceForm ref="maintenanceForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import MaintenanceForm from './maintenance';
import SubBtnBox from 'components/subBtnBox';
import {getVehicleMaintenanceRecord, doSaveVehicleMaintenanceRecord} from 'api/car';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    MaintenanceForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/car/maintain/maintenance/edit',
      formComponents: [
        'baseForm',
        'maintenanceForm',
      ],
      subLoading: false,
    };
  },
  computed: {
    detailParams () {
      return {
        id: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: getVehicleMaintenanceRecord,
    editApi: doSaveVehicleMaintenanceRecord,
    plateNumberChange (plateNumberInfo) {
      this.$refs.maintenanceForm.setFormVal(plateNumberInfo);
    },
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style>
</style>
